export const getDiscountedPrice = (price: number, discountP = 0) =>
  price * (1 - discountP / 100)
